module.exports = __webpack_public_path__ + "img/approval.e93f35b1.svg";